module.exports = __webpack_public_path__ + "static/media/uploadDocument.569d23e4.svg";